import { languages } from "../data/Languages";

export const GetCurrentLanguage = () => {
    const currentLanguageCode =
        // @ts-ignore
        JSON.parse(localStorage.getItem("i18next")) || "en";
    return languages.find((l) => l.code === currentLanguageCode);
};
